import React from "react";
import TransactionsPage from "@/pages/TransactionsPage";

export default function Income() {
  return (
    <TransactionsPage
      kind="income"
      title="Gelirler"
      subtitle="Kazançlar & Tahsilatlar"
      testidPrefix="income"
    />
  );
}
